import React from "react";
import { useState } from "react";
import RetryInstallment from "./RetryInstallment";
import RefreshInstallment from "./RefreshInstallment";
const InstallmentsPopup = ({
    isOpen,
    onClose,
    items = [],
    onRefresh,
    onRetry,
    onSkip,
    refreshPopupOpen,
    refreshedItem,
    onCloseRefreshPopup
}) => {

    const sortedItems = [...items].sort((a, b) => {
        if (!a?.due_date || !b?.due_date) return 0;
        return new Date(a.due_date) - new Date(b.due_date);
    });

    const [retryOpen, setRetryOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [retryDate, setRetryDate] = useState("");
    const [minRetryDate, setMinRetryDate] = useState("");
    const [view, setView] = useState("TABLE");

    if (!isOpen) return null;

    const formatDate = (date) =>
        date ? new Date(date).toLocaleDateString("en-GB") : "N/A";

    const statusColor = (state) => {
        switch (state) {
            case "CREATED":
                return "bg-blue-700 text-blue-100";
            case "SUCCESS":
                return "bg-green-700 text-green-100";
            case "FAILED":
                return "bg-red-700 text-red-100";
            case "TERMINATED":
                return "bg-orange-700 text-orange-100";
            case "CANCELLED":
                return "bg-red-600 text-red-100";
            default:
                return "bg-gray-700 text-gray-100";
        }
    };

    return (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-start  sm:items-center justify-center overflow-y-auto">
            <div className="bg-white w-[95%] max-w-7xl rounded-lg shadow-lg relative max-h-[95vh] flex flex-col">

                {/* HEADER */}
                <div className="border-b px-4 sm:px-6 py-4 relative sticky rounded-lg top-0 bg-white z-20">
                    <h3 className="text-2xl font-semibold text-center">
                        Installment Details
                    </h3>
                    <p className="text-sm text-center text-gray-600 mt-2">
                        In case of any issue, please click the <span className="font-medium">Refresh</span> button to update the data.
                    </p>
                    <button
                        onClick={onClose}
                        className="absolute right-4 top-4 text-gray-500 hover:text-gray-800 text-xl"
                    >
                        ✕
                    </button>
                </div>

                <div className="p-4 overflow-y-auto flex-1">
                    {view === "TABLE" && (
                        <>
                            {/* SCROLL CONTAINER */}
                            <div className="mb-4 px-3 py-2 bg-blue-50 border border-blue-200 rounded-lg text-sm text-gray-700">
                                <p className="flex flex-wrap gap-x-3 gap-y-1">
                                    <span><strong>Use Retry</strong> to reattempt the debit if the installment debit was failed due to any reason</span>
                                    <span className="text-gray-400">•</span>
                                    <span><strong>Use Refresh</strong> to get the updated details or view the details of the installment</span>
                                    <span className="text-gray-400">•</span>
                                    <span><strong>Use Skip</strong> if you do not want to debit the particular installment due to any reason</span>
                                </p>
                            </div>

                            <div className="max-h-[64vh] overflow-y-auto overflow-x-auto border border-gray-200 rounded">

                                <table className="min-w-[750px] w-full border border-gray-200 text-sm table-fixed">

                                    <thead className="bg-blue-700 text-white sticky top-0 z-10">
                                        <tr>
                                            <th className="p-2 text-center w-20">Installment</th>
                                            <th className="p-2 text-center w-20">Payer</th>
                                            <th className="p-2 text-center w-16">Amount</th>
                                            <th className="p-2 text-center w-20">Due Date</th>
                                            <th className="p-2 text-center w-20 hidden md:table-cell">Scheduled</th>
                                            <th className="p-2 text-center w-16">Status</th>
                                            <th className="p-2 text-center w-40">Action</th>

                                        </tr>
                                    </thead>

                                    <tbody>
                                        {sortedItems.length > 0 ? (
                                            sortedItems.map((item, index) => {

                                                return (
                                                    <tr
                                                        key={item.id}
                                                        className="border-t hover:bg-gray-50 align-middle"
                                                    >
                                                        <td className="p-2 text-center font-medium truncate">
                                                            {/* {item.client_meta?.description ||
                                                                `Inst- ${index + 1}`} */}
                                                                 Install-{index + 1}
                                                        </td>

                                                        <td className="p-2 text-center border-l">
                                                            <div className="font-medium"
                                                                title={item?.payer?.account?.name || "N/A"}>
                                                                {item?.payer?.account?.name?.length > 12
                                                                    ? `${item?.payer?.account?.name.slice(0, 12)}…`
                                                                    : item?.payer?.account?.name || "N/A"}
                                                            </div>

                                                            <div className="text-xs text-gray-500">
                                                                {item?.payer?.account?.mobile_number}
                                                            </div>
                                                        </td>

                                                        <td className="p-2 text-center font-semibold whitespace-nowrap border-l">
                                                            ₹ {Number(item?.payer?.amount?.value).toLocaleString("en-IN", {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 2,
                                                            })}
                                                        </td>

                                                        <td className="p-2 text-center whitespace-nowrap border-l">
                                                            {formatDate(item?.due_date)}
                                                        </td>

                                                        <td className="p-2 text-center whitespace-nowrap  hidden md:table-cell border-l">
                                                            {formatDate(item?.schedule_date)}
                                                        </td>

                                                        <td className="p-2 text-center whitespace-nowrap border-l"
                                                            title={item?.state}>
                                                            <span
                                                                className={`px-2 py-1 rounded text-xs font-medium ${statusColor(
                                                                    item?.state
                                                                )}`}
                                                            >
                                                                {item?.state?.length > 7
                                                                    ? `${item?.state?.slice(0, 7)}…`
                                                                    : item?.state}
                                                            </span>
                                                        </td>

                                                        <td className="p-2 text-center border-l">
                                                            <div className="flex flex-col sm:flex-row justify-center gap-2 whitespace-nowrap">
                                                                {/* Retry */}
                                                                <button
                                                                    // disabled={item?.state !== "CREATED"}
                                                                    onClick={() => {
                                                                        setSelectedItem(item);

                                                                        const baseDate = new Date(item?.due_date);
                                                                        baseDate.setDate(baseDate.getDate() + 3);

                                                                        const minDate = baseDate.toISOString().split("T")[0];

                                                                        setMinRetryDate(minDate);
                                                                        setRetryDate(minDate);
                                                                        setRetryOpen(true);
                                                                        setView("RETRY");
                                                                    }}
                                                                    className="px-2 py-1 rounded text-xs text-white
                 bg-red-600 hover:bg-red-700
                 disabled:opacity-40 disabled:cursor-not-allowed"
                                                                >
                                                                    Retry
                                                                </button>

                                                                {/* Refresh */}
                                                                <button
                                                                    onClick={() => {
                                                                        onRefresh(item);
                                                                        setSelectedItem(item);
                                                                        setView("REFRESH");
                                                                    }}
                                                                    className="px-2 py-1 rounded text-xs text-white
                 bg-blue-600 hover:bg-blue-700"
                                                                >
                                                                    Refresh
                                                                </button>

                                                                {/* Skip */}
                                                                <button
                                                                    disabled={item?.state !== "CREATED"}
                                                                    onClick={() => onSkip(item)}
                                                                    className="px-2 py-1 rounded text-xs text-white
                 bg-yellow-500 hover:bg-yellow-600
                 disabled:opacity-40 disabled:cursor-not-allowed"
                                                                >
                                                                    Skip
                                                                </button>

                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="12" className="p-4 text-center text-gray-500">
                                                    No installments found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                    {view === "RETRY" && selectedItem && (
                        <RetryInstallment
                            item={selectedItem}
                            retryDate={retryDate}
                            minRetryDate={minRetryDate}
                            setRetryDate={setRetryDate}
                            onBack={() => setView("TABLE")}
                            onSubmit={() => {
                                onRetry(selectedItem, retryDate);
                                setView("TABLE");
                            }}
                        />
                    )}

                    {view === "REFRESH" && selectedItem && (
                        <RefreshInstallment
                            item={refreshedItem}
                            onBack={() => setView("TABLE")}
                        />
                    )}
                </div>
            </div >
        </div>
    );
};

export default InstallmentsPopup;
